import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class PlatformService extends Service {
  @tracked isNative = false;
  @tracked shell = null;

  openUrl(url){
    if (this.isNative) {
      this.shell.openExternal(url);
    } else {
      window.open(url);
    }
  }

  constructor(...args) {
    super(...args);

    //console.log('window.require = ', window.require)
    //console.log('window.requireNode = ', window.requireNode)

    try {
      let shell = window.requireNode('electron').shell;
      this.isNative = true;
      this.shell = shell;
    } catch (e) {
      console.error('we could not require electron - setting isNative: false')
      console.error(e);
      // fall through
    }
  }
}
